/* eslint-disable @typescript-eslint/no-explicit-any */
import { MutableRefObject } from 'react';
import { useTranslation } from 'react-i18next';

import { CustomGridApi } from '../../common/XTable/types';
import XTabs from '../../common/XTabs';
import InfoAdditional from './InfoAdditional';
import InfoMore from './InfoMore';

const ResultInfoSidebar = ({
 apiRef,
 item,
}: {
 apiRef: MutableRefObject<CustomGridApi>;
 item: any;
}) => {
 const { t } = useTranslation();

 const tabs = [
  {
   id: 'details',
   label: t('global.details'),
   content: <InfoMore apiRef={apiRef} data={item} />,
  },
  {
   id: 'additional',
   label: t('global.additional'),
   content: <InfoAdditional data={item} />,
  },
 ];

 return <XTabs tabs={tabs} ariaLabel="Info sidebar" />;
};
export default ResultInfoSidebar;
